"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_BUNDLE_FILE_NAME = void 0;
exports.WIDGET_BUNDLE_FILE_NAME = 'cashier-express-checkout-widget';
//# sourceMappingURL=constants.js.map